import { ApiClient } from './api'
import AuthService from './AuthService'
import CustomsV2Service from './CustomsV2Service'
import { InboundV2Service } from './InboundV2Service'
import { OutboundV2Service } from './OutboundV2Service'
import PalletV2Service from './PalletV2Service'
import { QZPrintService } from './QZPrintService'
import SearchV2Service from './SearchV2Service'
import StatisticsV2Service from './StatisticsV2Service'
import { StorageService } from './StorageService'
import WarehouseV2Service from './WarehouseV2Service'

// 创建API客户端实例
const apiClient = new ApiClient({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 10000,
  withAuth: true,
  mockEnabled: import.meta.env.VITE_ENABLE_MOCK === 'true'
})

// 创建无认证的API客户端实例（用于登录等不需要token的接口）
const publicApiClient = new ApiClient({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 10000,
  withAuth: false,
  mockEnabled: import.meta.env.VITE_ENABLE_MOCK === 'true'
})

// 通用服务
export const authService = new AuthService(publicApiClient)
export const storageService = new StorageService(apiClient)
export const qzPrintService = new QZPrintService(apiClient)

// 创建服务实例v2
export const customsV2Service = new CustomsV2Service(apiClient)
export const inboundV2Service = new InboundV2Service(apiClient)
export const palletV2Service = new PalletV2Service(apiClient)
export const outboundV2Service = new OutboundV2Service(apiClient)
export const statisticsV2Service = new StatisticsV2Service(apiClient)
export const searchV2Service = new SearchV2Service(apiClient)
export const warehouseV2Service = new WarehouseV2Service(apiClient)

// 导出类型定义
export type { ApiClient } from './api'

// 导出API客户端实例，供特殊需求使用
export { apiClient, publicApiClient }
